import React, { type FC } from 'react';
import styles from './saleIndicator.scss';
import { translate } from '#packages/i18n';
import { cx } from '#packages/util';

interface SaleIndicatorProps {
  isActive: boolean;
  personalSaleCampaignDiscountValue: number;
}

const SaleIndicator: FC<SaleIndicatorProps> = ({
  isActive,
  personalSaleCampaignDiscountValue,
}) => {
  return (
    <div
      className={cx(styles.saleIndicator, {
        [styles.saleIndicator_active]: isActive,
      })}
    >
      {translate('tobar_premium_sale_off_label', {
        sale_percent: personalSaleCampaignDiscountValue.toString(),
      })}
    </div>
  );
};

export default SaleIndicator;
